// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  environmentName: 'DEV',
  amerenUrl: 'https://www.dev.ameren.com',
  gaTrackingCode: 'GTM-TZSWW62',
  analyticsEnabled: true,
  api: {
    baseUrl: 'https://pm-api-dev.ameren.com',
    cssEnv: 'css.ptst',
    vpcenv: 'dev',
  },
  auth: {
    authority: 'https://login.ciam-dev.ece.ameren.com/oauth2/realms/root/realms/ameren/authorize',
    clientId: '8484ed68-bc2c-438c-980a-1d6ec03dac7f',
    scope:
      'openid profile ismemberof imp_username imp_email imp_role READ:ENRICHMENT:ADDRESS READ:CUSTOMER:PREMISES READ:CUSTOMER:PARTY READ:CUSTOMER:PARTNER',
    useMockAccountInfo: true,
  },
  splunk: {
    index: 'corp_digital_pm_dev',
    token: '617b0b25-dd6c-4469-855f-b9368a157a44',
    url: 'https://splunkcloudhec.ameren.com:443/services/collector',
  },

  dynatrace: {
    script: '',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error' // Included with Angular CLI.
